import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { UNIT_MAX_LENGTH } from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const UnitInput = (props: Props) => {
  const { name, label, containerClassName, required } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      name={name}
      label={label}
      maxLength={UNIT_MAX_LENGTH}
      control={control}
      clearErrors={clearErrors}
      autoComplete={uuidv4()}
      containerClassName={containerClassName}
      required={required}
    />
  );
};

export default UnitInput;
